import { createWebHistory, createRouter } from "vue-router";

import routes from "../routes";
import store from "../store";
import helper from "../util/helper";
import dateFormat from "dateformat";

export const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    // next();
    let active_user = store ? store.state.auth.user : null;

    // public route ကို login နဲ့ permission စစ်ချက်တွေ မတိုင်ခင် ဖွင့်ပေးတယ် — မဟုတ်ရင်
    // checkPermissionForRoute() က permission မရှိတဲ့ route လို့ ယူဆပြီး /403 ဆီ ပို့မယ်၊
    // /403 က auth: true ဖြစ်လို့ login မဝင်ထားသူကို login page ဆီ ထပ်ပို့မယ်။
    if (helper.isPublicRoute(to)) {
        return next();
    }

    if (
        to.matched.some((m) => m.meta.auth) &&
        !helper.castBool(store.state.auth.authenticated)
    ) {
        //! store.state.auth.authenticated
        /*
         * If the user is not authenticated and visits
         * a page that requires authentication, redirect to the login page
         */
        next({
            name: "login", //redo set login
        });
    } else if (
        to.matched.some((m) => m.meta.guest) &&
        helper.castBool(store.state.auth.authenticated)
    ) {
        /*
         * If the user is authenticated and visits
         * an guest page, redirect to the dashboard page
         */
        next({
            path: "/",
        });
    } else if (
        !helper.checkPermissionForRoute(
            to.name,
            to.params ? to.params.permit : undefined
        ) && //if invalid permission
        !helper.isGlobalRoute(to) && //if not global route
        !helper.isGuestRoute(to)
    ) {
        next({
            name: "unauthorized",
        });
    } else {
        let title = "";
        // This goes through the matched routes from last to first, finding the closest route with a title.
        // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
        const nearestWithTitle = to.matched
            .slice()
            .reverse()
            .find((r) => r.meta && r.meta.title);
        if (nearestWithTitle) title = nearestWithTitle.meta.title;

        const compoenentTitle = to.matched
            .slice()
            .reverse()
            .find(
                (r) =>
                    r.components &&
                    r.components.default &&
                    r.components.default.name
            );
        if (compoenentTitle)
            title = `${compoenentTitle.components.default.name} | ${
                active_user.name ? active_user.name : "Delivery"
            }`;

        // If a route with a title was found, set the document (page) title to that value.
        if (title) document.title = title;

        const windowExpiredTime = windowIdSet(6);

        let time = new Date().getTime() + 3 * 3600 * 1000; // Get milliseconds
        let date = new Date(time); // Milliseconds to date

        let historyRouteFormatted = {
            fullPath: to.fullPath,
            meta: to.meta,
            name: to.name,
            params: to.params,
            windowExpiredTime:
                windowExpiredTime == false
                    ? date.toLocaleString()
                    : windowExpiredTime,
        };

        store.dispatch("cache/routeHistory", historyRouteFormatted);

        next();
    }
});

const windowIdSet = (h) => {
    if (!window.name) {
        window.name = "window_" + parseInt(Math.random() * 1000000000);
        let time = new Date().getTime() + h * 3600 * 1000; // Get milliseconds
        let date = new Date(time); // Milliseconds to date
        return date.toLocaleString();
        // return parseInt(dateFormat((new Date()).getTime() + (h * 3600 * 1000), 'HH'));
    }
    return false;
};

router.onError((error) => {
    console.error("load fail ", error);
    if (/loading chunk \d* failed./i.test(error.message)) {
        window.location.reload();
    }
});
